import { Form } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../components/DraggableModal";
import { EntUser } from "../../../models/user";
import { NewPass } from "../../../models/newPass";
import InputPassword from "../../../components/inputs/inputPassword";

enum FormField {
    pin,
    password
}
interface IProps {
    show: boolean;
    user: EntUser;
    passwordLength?: number | null;
    onHide: () => void;
    onSubmit: (pos: NewPass) => Promise<boolean>;
}

export const ChangePassUserModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);

    const getMaxPasswordLength = (roles: Array<any>) => {
        return Math.max(...roles.map(role => role.passwordLength));
    }

    const currPassLen = props.user.roles ? getMaxPasswordLength(props.user.roles) : null;

    const setEntityFromFields = (): NewPass => {
        let userPsw = _.cloneDeep(new NewPass);
        userPsw.pin = props.user.pin;
        userPsw.password = form.getFieldValue(FormField.password);

        return userPsw;
    }
    const onHideModal = () => {
        props.onHide();
        form.setFields([
            { name: FormField.password, value: null },
        ]);
    }
    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            const result = await props.onSubmit(data);
            if (result) onHideModal()
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <DraggableModal
                title={t('auth.change_password')}
                visible={props.show}
                onCancel={onHideModal}
                onSubmit={handleSubmit}
                submitLoading={loading}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >
                    <Form.Item
                        label={t('auth.new_password')}
                        name={FormField.password}
                        rules={[
                            { required: true, message: t("msg.fill_in_the_field") },
                            { pattern: new RegExp(/^.*(?=.{8,})(?=.*[a-zA-Z])(?=.*\d)(?=.*[!#$%&? ".]).*$/, 'g'), message: t('auth.passwordValidationErrorMessage') }
                        ]}
                        hasFeedback
                    >

                        <InputPassword passwordLength={currPassLen}/>
                    </Form.Item>
                </Form>
            </DraggableModal>
        </>

    )
}
